import { mergeProps, splitProps, type ComponentProps } from "solid-js";
import { Dynamic } from "solid-js/web";
import clsx from "~/util/html/style";

// DEPRECATED: Use the Icon component instead
/* eslint-disable @typescript-eslint/no-restricted-imports */
export { default as ArrowDownOnSquareStack } from "heroicons/24/outline/arrow-down-on-square-stack.svg?component-solid";
export { default as ArrowDownTray } from "heroicons/24/outline/arrow-down-tray.svg?component-solid";
export { default as ArrowsPointingOut } from "heroicons/24/outline/arrows-pointing-out.svg?component-solid";
export { default as ArrowLeft } from "heroicons/24/outline/arrow-left.svg?component-solid";
export { default as ArrowsRightLeft } from "heroicons/24/outline/arrows-right-left.svg?component-solid";
export { default as ArrowsUpDown } from "heroicons/24/outline/arrows-up-down.svg?component-solid";
export { default as ArrowTopRightOnSquare } from "heroicons/24/outline/arrow-top-right-on-square.svg?component-solid";
export { default as ArrowUturnLeft } from "heroicons/24/outline/arrow-uturn-left.svg?component-solid";
export { default as ArrowUturnRight } from "heroicons/24/outline/arrow-uturn-right.svg?component-solid";
export { default as ArrowUpTray } from "heroicons/24/outline/arrow-up-tray.svg?component-solid";
export { default as Banknotes } from "heroicons/24/outline/banknotes.svg?component-solid";
export { default as BuildingOffice } from "heroicons/24/outline/building-office.svg?component-solid";
export { default as Calendar } from "heroicons/24/outline/calendar.svg?component-solid";
export { default as Camera } from "heroicons/24/outline/camera.svg?component-solid";
export { default as Check } from "heroicons/24/outline/check.svg?component-solid";
export { default as CheckCircle } from "heroicons/24/outline/check-circle.svg?component-solid";
export { default as ChevronDown } from "heroicons/24/outline/chevron-down.svg?component-solid";
export { default as ChevronLeft } from "heroicons/24/outline/chevron-left.svg?component-solid";
export { default as ChevronRight } from "heroicons/24/outline/chevron-right.svg?component-solid";
export { default as ChevronUp } from "heroicons/24/outline/chevron-up.svg?component-solid";
export { default as CurrencyDollar } from "heroicons/24/outline/currency-dollar.svg?component-solid";
export { default as Document } from "heroicons/24/outline/document.svg?component-solid";
export { default as DocumentCurrencyDollar } from "heroicons/24/outline/document-currency-dollar.svg?component-solid";
export { default as DocumentDuplicate } from "heroicons/24/outline/document-duplicate.svg?component-solid";
export { default as ExclamationCircle } from "heroicons/24/outline/exclamation-circle.svg?component-solid";
export { default as ExclamationTriangle } from "heroicons/24/outline/exclamation-triangle.svg?component-solid";
export { default as EyeSlash } from "heroicons/24/outline/eye-slash.svg?component-solid";
export { default as FaceSmile } from "heroicons/24/outline/face-smile.svg?component-solid";
export { default as HandThumbUp } from "heroicons/24/outline/hand-thumb-up.svg?component-solid";
export { default as Home } from "heroicons/24/outline/home.svg?component-solid";
export { default as InformationCircle } from "heroicons/24/outline/information-circle.svg?component-solid";
export { default as LinkSlash } from "heroicons/24/outline/link-slash.svg?component-solid";
export { default as LockClosed } from "heroicons/24/outline/lock-closed.svg?component-solid";
export { default as LockOpen } from "heroicons/24/outline/lock-open.svg?component-solid";
export { default as MagnifyingGlass } from "heroicons/24/outline/magnifying-glass.svg?component-solid";
export { default as Newspaper } from "heroicons/24/outline/newspaper.svg?component-solid";
import NewspaperOutline from "heroicons/24/outline/newspaper.svg?component-solid";
import NewspaperSolid from "heroicons/24/solid/newspaper.svg?component-solid";
export { default as PaperClip } from "heroicons/24/outline/paper-clip.svg?component-solid";
export { default as Pause } from "heroicons/24/outline/pause.svg?component-solid";
export { default as Pencil } from "heroicons/24/outline/pencil.svg?component-solid";
export { default as PencilSquare } from "heroicons/24/outline/pencil-square.svg?component-solid";
export { default as Play } from "heroicons/24/outline/play.svg?component-solid";
export { default as Plus } from "heroicons/24/outline/plus.svg?component-solid";
export { default as PlusCircle } from "heroicons/24/outline/plus-circle.svg?component-solid";
export { default as Square2Stack } from "heroicons/24/outline/square-2-stack.svg?component-solid";
export { default as Printer } from "heroicons/24/outline/printer.svg?component-solid";
export { default as Trash } from "heroicons/24/outline/trash.svg?component-solid";
export { default as UserPlus } from "heroicons/24/outline/user-plus.svg?component-solid";
export { default as Users } from "heroicons/24/outline/users.svg?component-solid";
export { default as Window } from "heroicons/24/outline/window.svg?component-solid";
export { default as XCircle } from "heroicons/24/outline/x-circle.svg?component-solid";
export { default as XMark } from "heroicons/24/outline/x-mark.svg?component-solid";
export { default as ChatBubbleOvalLeftEllipsis } from "heroicons/24/outline/chat-bubble-oval-left-ellipsis.svg?component-solid";

import ChartPie from "heroicons/24/outline/chart-pie.svg?component-solid";
import ChartPieSolid from "heroicons/24/solid/chart-pie.svg?component-solid";
import ArrowLeftEndOnRectangle from "heroicons/24/outline/arrow-left-end-on-rectangle.svg?component-solid";
import ArrowLeftEndOnRectangleSolid from "heroicons/24/solid/arrow-left-end-on-rectangle.svg?component-solid";
import ArrowLeft from "heroicons/24/outline/arrow-left.svg?component-solid";
import ArrowLeftSolid from "heroicons/24/solid/arrow-left.svg?component-solid";
import ArrowRight from "heroicons/24/outline/arrow-right.svg?component-solid";
import ArrowRightSolid from "heroicons/24/solid/arrow-right.svg?component-solid";
import ArrowUp from "heroicons/24/outline/arrow-up.svg?component-solid";
import ArrowUpSolid from "heroicons/24/solid/arrow-up.svg?component-solid";
import ArrowDown from "heroicons/24/outline/arrow-down.svg?component-solid";
import ArrowDownSolid from "heroicons/24/solid/arrow-down.svg?component-solid";
import ArrowDownLeft from "heroicons/24/outline/arrow-down-left.svg?component-solid";
import ArrowDownLeftSolid from "heroicons/24/solid/arrow-down-left.svg?component-solid";
import ArrowUpRight from "heroicons/24/outline/arrow-up-right.svg?component-solid";
import ArrowUpRightSolid from "heroicons/24/solid/arrow-up-right.svg?component-solid";
import ChevronLeft from "heroicons/24/outline/chevron-left.svg?component-solid";
import ChevronLeftSolid from "heroicons/24/solid/chevron-left.svg?component-solid";
import ChevronRight from "heroicons/24/outline/chevron-right.svg?component-solid";
import ChevronRightSolid from "heroicons/24/solid/chevron-right.svg?component-solid";
import ChevronDoubleRight from "heroicons/24/outline/chevron-double-right.svg?component-solid";
import ChevronDoubleRightSolid from "heroicons/24/solid/chevron-double-right.svg?component-solid";
import ChevronUp from "heroicons/24/outline/chevron-up.svg?component-solid";
import ChevronUpSolid from "heroicons/24/solid/chevron-up.svg?component-solid";
import ChevronDown from "heroicons/24/outline/chevron-down.svg?component-solid";
import ChevronDownSolid from "heroicons/24/solid/chevron-down.svg?component-solid";
import AdjustmentsHorizontal from "heroicons/24/outline/adjustments-horizontal.svg?component-solid";
import AdjustmentsHorizontalSolid from "heroicons/24/solid/adjustments-horizontal.svg?component-solid";
import FaceSmileIcon from "heroicons/24/outline/face-smile.svg?component-solid";
import FaceSmileSolidIcon from "heroicons/24/solid/face-smile.svg?component-solid";
import InformationCircle from "heroicons/24/outline/information-circle.svg?component-solid";
import InformationCircleSolid from "heroicons/24/solid/information-circle.svg?component-solid";
import BuildingStorefront from "heroicons/24/outline/building-storefront.svg?component-solid";
import BuildingStorefrontSolid from "heroicons/24/solid/building-storefront.svg?component-solid";
import Identification from "heroicons/24/outline/identification.svg?component-solid";
import IdentificationSolid from "heroicons/24/solid/identification.svg?component-solid";
import Ticket from "heroicons/24/outline/ticket.svg?component-solid";
import TicketSolid from "heroicons/24/solid/ticket.svg?component-solid";
import Map from "heroicons/24/outline/map.svg?component-solid";
import MapSolid from "heroicons/24/solid/map.svg?component-solid";
import DocumentCurrencyDollar from "heroicons/24/outline/document-currency-dollar.svg?component-solid";
import DocumentCurrencyDollarSolid from "heroicons/24/solid/document-currency-dollar.svg?component-solid";
import NumberedList from "heroicons/24/outline/numbered-list.svg?component-solid";
import NumberedListSolid from "heroicons/24/solid/numbered-list.svg?component-solid";
import User from "heroicons/24/outline/user.svg?component-solid";
import UserSolid from "heroicons/24/solid/user.svg?component-solid";
import Envelope from "heroicons/24/outline/envelope.svg?component-solid";
import EnvelopeSolid from "heroicons/24/solid/envelope.svg?component-solid";
import ArrowsRightLeft from "heroicons/24/outline/arrows-right-left.svg?component-solid";
import ArrowsRightLeftSolid from "heroicons/24/solid/arrows-right-left.svg?component-solid";
import ArrowsUpDown from "heroicons/24/outline/arrows-up-down.svg?component-solid";
import ArrowsUpDownSolid from "heroicons/24/solid/arrows-up-down.svg?component-solid";
import XMark from "heroicons/24/outline/x-mark.svg?component-solid";
import XMarkSolid from "heroicons/24/solid/x-mark.svg?component-solid";
import Squares2X2 from "heroicons/24/outline/squares-2x2.svg?component-solid";
import Squares2X2Solid from "heroicons/24/solid/squares-2x2.svg?component-solid";
import Flag from "heroicons/24/outline/flag.svg?component-solid";
import FlagSolid from "heroicons/24/solid/flag.svg?component-solid";
import Phone from "heroicons/24/outline/phone.svg?component-solid";
import PhoneSolid from "heroicons/24/solid/phone.svg?component-solid";
import PhoneArrowDownLeft from "heroicons/24/outline/phone-arrow-down-left.svg?component-solid";
import PhoneArrowDownLeftSolid from "heroicons/24/solid/phone-arrow-down-left.svg?component-solid";
import Play from "heroicons/24/outline/play.svg?component-solid";
import PlaySolid from "heroicons/24/solid/play.svg?component-solid";
import PrinterIcon from "heroicons/24/outline/printer.svg?component-solid";
import PrinterIconSolid from "heroicons/24/solid/printer.svg?component-solid";
import Pause from "heroicons/24/outline/pause.svg?component-solid";
import PauseSolid from "heroicons/24/solid/pause.svg?component-solid";
import Stop from "heroicons/24/outline/stop.svg?component-solid";
import StopSolid from "heroicons/24/solid/stop.svg?component-solid";
import ArrowTopRightOnSquare from "heroicons/24/outline/arrow-top-right-on-square.svg?component-solid";
import ArrowTopRightOnSquareSolid from "heroicons/24/solid/arrow-top-right-on-square.svg?component-solid";
import PaperClipIcon from "heroicons/24/outline/paper-clip.svg?component-solid";
import PaperClipIconSolid from "heroicons/24/solid/paper-clip.svg?component-solid";
import XCircle from "heroicons/24/outline/x-circle.svg?component-solid";
import XCircleSolid from "heroicons/24/solid/x-circle.svg?component-solid";
import PhoneXMark from "heroicons/24/outline/phone-x-mark.svg?component-solid";
import PhoneXMarkSolid from "heroicons/24/solid/phone-x-mark.svg?component-solid";
import Hashtag from "heroicons/24/outline/hashtag.svg?component-solid";
import HashtagSolid from "heroicons/24/solid/hashtag.svg?component-solid";
import Bolt from "heroicons/24/outline/bolt.svg?component-solid";
import BoltSolid from "heroicons/24/solid/bolt.svg?component-solid";
import Heart from "heroicons/24/outline/heart.svg?component-solid";
import HeartSolid from "heroicons/24/solid/heart.svg?component-solid";
import CurrencyDollar from "heroicons/24/outline/currency-dollar.svg?component-solid";
import CurrencyDollarSolid from "heroicons/24/solid/currency-dollar.svg?component-solid";
import ShieldCheck from "heroicons/24/outline/shield-check.svg?component-solid";
import ShieldCheckSolid from "heroicons/24/solid/shield-check.svg?component-solid";
import EligibilityBadge from "@assets/images/icons/eligibility.svg?component-solid";
import BenefitsBadge from "@assets/images/icons/benefits.svg?component-solid";
import BenefitsFilledBadge from "@assets/images/icons/benefits-filled.svg?component-solid";
import HistoryBadge from "@assets/images/icons/history.svg?component-solid";
import Pill from "@assets/images/icons/pill.svg?component-solid";
import CheckCircle from "heroicons/24/outline/check-circle.svg?component-solid";
import CheckCircleSolid from "heroicons/24/solid/check-circle.svg?component-solid";
import ChatBubbleLeft from "heroicons/24/outline/chat-bubble-left.svg?component-solid";
import ChatBubbleLeftSolid from "heroicons/24/solid/chat-bubble-left.svg?component-solid";
import ChatBubbleLeftRight from "heroicons/24/outline/chat-bubble-left-right.svg?component-solid";
import ChatBubbleLeftRightSolid from "heroicons/24/solid/chat-bubble-left-right.svg?component-solid";
import Clock from "heroicons/24/outline/clock.svg?component-solid";
import ClockSolid from "heroicons/24/solid/clock.svg?component-solid";
import Beaker from "heroicons/24/outline/beaker.svg?component-solid";
import BeakerSolid from "heroicons/24/solid/beaker.svg?component-solid";
import EllipsisVertical from "heroicons/24/outline/ellipsis-vertical.svg?component-solid";
import EllipsisVerticalSolid from "heroicons/24/solid/ellipsis-vertical.svg?component-solid";
import EllipsisHorizontal from "heroicons/24/outline/ellipsis-horizontal.svg?component-solid";
import EllipsisHorizontalSolid from "heroicons/24/solid/ellipsis-horizontal.svg?component-solid";
import DocumentCheck from "heroicons/24/outline/document-check.svg?component-solid";
import DocumentCheckSolid from "heroicons/24/solid/document-check.svg?component-solid";
import Calendar from "heroicons/24/outline/calendar.svg?component-solid";
import CalendarSolid from "heroicons/24/solid/calendar.svg?component-solid";
import DocumentText from "heroicons/24/outline/document-text.svg?component-solid";
import DocumentTextSolid from "heroicons/24/solid/document-text.svg?component-solid";
import PlainDocument from "heroicons/24/outline/document.svg?component-solid";
import PlainDocumentSolid from "heroicons/24/solid/document.svg?component-solid";
import Photo from "heroicons/24/outline/photo.svg?component-solid";
import PhotoSolid from "heroicons/24/solid/photo.svg?component-solid";
import Cake from "heroicons/24/outline/cake.svg?component-solid";
import CakeSolid from "heroicons/24/solid/cake.svg?component-solid";
import UserGroup from "heroicons/24/outline/user-group.svg?component-solid";
import UserGroupSolid from "heroicons/24/solid/user-group.svg?component-solid";
import LightBulb from "heroicons/24/outline/light-bulb.svg?component-solid";
import LightBulbSolid from "heroicons/24/solid/light-bulb.svg?component-solid";
import ArrowTrendingUp from "heroicons/24/outline/arrow-trending-up.svg?component-solid";
import ArrowTrendingUpSolid from "heroicons/24/solid/arrow-trending-up.svg?component-solid";
import ArrowTrendingDown from "heroicons/24/outline/arrow-trending-down.svg?component-solid";
import ArrowTrendingDownSolid from "heroicons/24/solid/arrow-trending-down.svg?component-solid";
import ArrowUpCircle from "heroicons/24/outline/arrow-up-circle.svg?component-solid";
import ArrowUpCircleSolid from "heroicons/24/solid/arrow-up-circle.svg?component-solid";
import ArrowDownCircle from "heroicons/24/outline/arrow-down-circle.svg?component-solid";
import ArrowDownCircleSolid from "heroicons/24/solid/arrow-down-circle.svg?component-solid";
import Plus from "heroicons/24/outline/plus.svg?component-solid";
import PlusSolid from "heroicons/24/solid/plus.svg?component-solid";
import Trash from "heroicons/24/outline/trash.svg?component-solid";
import TrashSolid from "heroicons/24/solid/trash.svg?component-solid";
import ArrowUturnLeft from "heroicons/24/outline/arrow-uturn-left.svg?component-solid";
import CursorArrowRays from "heroicons/24/outline/cursor-arrow-rays.svg?component-solid";
import CursorArrowRaysSolid from "heroicons/24/solid/cursor-arrow-rays.svg?component-solid";
import ArrowUturnLeftSolid from "heroicons/24/solid/arrow-uturn-left.svg?component-solid";
import ArrowUturnRight from "heroicons/24/outline/arrow-uturn-right.svg?component-solid";
import ArrowUturnRightSolid from "heroicons/24/solid/arrow-uturn-right.svg?component-solid";
import ArrowUpTrayIcon from "heroicons/24/outline/arrow-up-tray.svg?component-solid";
import ArrowUpTrayIconSolid from "heroicons/24/solid/arrow-up-tray.svg?component-solid";
import EllipsisHorizontalCircle from "heroicons/24/outline/ellipsis-horizontal-circle.svg?component-solid";
import EllipsisHorizontalCircleSolid from "heroicons/24/solid/ellipsis-horizontal-circle.svg?component-solid";
import BuildingOffice2 from "heroicons/24/outline/building-office-2.svg?component-solid";
import BuildingOffice2Solid from "heroicons/24/solid/building-office-2.svg?component-solid";
import Star from "heroicons/24/outline/star.svg?component-solid";
import StarSolid from "heroicons/24/solid/star.svg?component-solid";
import AcademicCap from "heroicons/24/outline/academic-cap.svg?component-solid";
import AcademicCapSolid from "heroicons/24/solid/academic-cap.svg?component-solid";
import BookOpen from "heroicons/24/outline/book-open.svg?component-solid";
import BookOpenSolid from "heroicons/24/solid/book-open.svg?component-solid";
import Sparkle from "@assets/images/icons/sparkle.svg?component-solid";
import PanelLeft from "@assets/images/icons/panel-left.svg?component-solid";
import MicrophoneSlash from "@assets/images/icons/microphone-slash.svg?component-solid";
import TwelveMark from "@assets/images/icons/twelve-mark.svg?component-solid";
import TweveMarkMono from "@assets/images/icons/twelve-mark-mono.svg?component-solid";
import UnifyU from "@assets/images/icons/unify-u.svg?component-solid";
import Sparkles from "heroicons/24/outline/sparkles.svg?component-solid";
import SparklesSolid from "heroicons/24/solid/sparkles.svg?component-solid";
import LockOpen from "heroicons/24/outline/lock-open.svg?component-solid";
import LockOpenSolid from "heroicons/24/solid/lock-open.svg?component-solid";
import LockClosed from "heroicons/24/outline/lock-closed.svg?component-solid";
import LockClosedSolid from "heroicons/24/solid/lock-closed.svg?component-solid";
import Check from "heroicons/24/outline/check.svg?component-solid";
import CheckSolid from "heroicons/24/solid/check.svg?component-solid";
import PencilIcon from "heroicons/24/outline/pencil.svg?component-solid";
import PencilIconSolid from "heroicons/24/solid/pencil.svg?component-solid";
import QuestionMarkCircle from "heroicons/24/outline/question-mark-circle.svg?component-solid";
import QuestionMarkCircleSolid from "heroicons/24/solid/question-mark-circle.svg?component-solid";
import Banknotes from "heroicons/24/outline/banknotes.svg?component-solid";
import BanknotesSolid from "heroicons/24/solid/banknotes.svg?component-solid";
import CreditCard from "heroicons/24/outline/credit-card.svg?component-solid";
import CreditCardSolid from "heroicons/24/solid/credit-card.svg?component-solid";
import MagnifyingGlass from "heroicons/24/outline/magnifying-glass.svg?component-solid";
import MagnifyingGlassSolid from "heroicons/24/solid/magnifying-glass.svg?component-solid";
import Clipboard from "heroicons/24/outline/clipboard.svg?component-solid";
import ClipboardSolid from "heroicons/24/solid/clipboard.svg?component-solid";
import ClipboardDocumentList from "heroicons/24/outline/clipboard-document-list.svg?component-solid";
import ClipboardDocumentListSolid from "heroicons/24/solid/clipboard-document-list.svg?component-solid";
import CheckBadge from "heroicons/24/outline/check-badge.svg?component-solid";
import CheckBadgeSolid from "heroicons/24/solid/check-badge.svg?component-solid";
import ExclamationTriangleIcon from "heroicons/24/outline/exclamation-triangle.svg?component-solid";
import ExclamationTriangleIconSolid from "heroicons/24/solid/exclamation-triangle.svg?component-solid";
import UserPlus from "heroicons/24/outline/user-plus.svg?component-solid";
import UserPlusSolid from "heroicons/24/solid/user-plus.svg?component-solid";
import Microphone from "heroicons/24/outline/microphone.svg?component-solid";
import MicrophoneSolid from "heroicons/24/solid/microphone.svg?component-solid";
import ArrowDownTray from "heroicons/24/outline/arrow-down-tray.svg?component-solid";
import ArrowDownTraySolid from "heroicons/24/solid/arrow-down-tray.svg?component-solid";
import ArrowPath from "heroicons/24/outline/arrow-path.svg?component-solid";
import ArrowPathSolid from "heroicons/24/solid/arrow-path.svg?component-solid";
import Funnel from "heroicons/24/outline/funnel.svg?component-solid";
import FunnelSolid from "heroicons/24/solid/funnel.svg?component-solid";
import CloudArrowUp from "heroicons/24/outline/cloud-arrow-up.svg?component-solid";
import CloudArrowUpSolid from "heroicons/24/solid/cloud-arrow-up.svg?component-solid";
import Cog6Tooth from "heroicons/24/outline/cog-6-tooth.svg?component-solid";
import Cog6ToothSolid from "heroicons/24/solid/cog-6-tooth.svg?component-solid";
import Bars3 from "heroicons/24/outline/bars-3.svg?component-solid";
import Bars3Solid from "heroicons/24/solid/bars-3.svg?component-solid";
import HandThumbDown from "heroicons/24/outline/hand-thumb-down.svg?component-solid";
import HandThumbDownSolid from "heroicons/24/solid/hand-thumb-down.svg?component-solid";
import HandThumbUpIcon from "heroicons/24/outline/hand-thumb-up.svg?component-solid";
import HandThumbUpIconSolid from "heroicons/24/solid/hand-thumb-up.svg?component-solid";
import PresentationChartLine from "heroicons/24/outline/presentation-chart-line.svg?component-solid";
import PresentationChartLineSolid from "heroicons/24/solid/presentation-chart-line.svg?component-solid";
import UsersIcon from "heroicons/24/outline/users.svg?component-solid";
import UsersIconSolid from "heroicons/24/solid/users.svg?component-solid";
import ChatBubbleOvalLeft from "heroicons/24/outline/chat-bubble-oval-left.svg?component-solid";
import ChatBubbleOvalLeftSolid from "heroicons/24/solid/chat-bubble-oval-left.svg?component-solid";
import ChartBar from "heroicons/24/outline/chart-bar.svg?component-solid";
import ChartBarSolid from "heroicons/24/solid/chart-bar.svg?component-solid";
import MapPin from "heroicons/24/outline/map-pin.svg?component-solid";
import MapPinSolid from "heroicons/24/solid/map-pin.svg?component-solid";
import BuildingOfficeIcon from "heroicons/24/outline/building-office.svg?component-solid";
import BuildingOfficeIconSolid from "heroicons/24/solid/building-office.svg?component-solid";
import Eye from "heroicons/24/outline/eye.svg?component-solid";
import EyeSolid from "heroicons/24/solid/eye.svg?component-solid";
import EyeSlashIcon from "heroicons/24/outline/eye-slash.svg?component-solid";
import EyeSlashIconSolid from "heroicons/24/solid/eye-slash.svg?component-solid";
import Cog from "heroicons/24/outline/cog.svg?component-solid";
import CogSolid from "heroicons/24/solid/cog.svg?component-solid";
import Tag from "heroicons/24/outline/tag.svg?component-solid";
import TagSolid from "heroicons/24/solid/tag.svg?component-solid";
import FolderIcon from "heroicons/24/outline/folder.svg?component-solid";
import FolderIconSolid from "heroicons/24/solid/folder.svg?component-solid";
import FolderOpen from "heroicons/24/outline/folder-open.svg?component-solid";
import FolderOpenSolid from "heroicons/24/solid/folder-open.svg?component-solid";
import FolderPlus from "heroicons/24/outline/folder-plus.svg?component-solid";
import FolderPlusSolid from "heroicons/24/solid/folder-plus.svg?component-solid";
import Minus from "heroicons/24/outline/minus.svg?component-solid";
import MinusSolid from "heroicons/24/solid/minus.svg?component-solid";
import PaperAirplane from "heroicons/24/outline/paper-airplane.svg?component-solid";
import PaperAirplaneSolid from "heroicons/24/solid/paper-airplane.svg?component-solid";
import Link from "heroicons/24/outline/link.svg?component-solid";
import LinkSolid from "heroicons/24/solid/link.svg?component-solid";
import LinkSlashIcon from "heroicons/24/outline/link-slash.svg?component-solid";
import LinkSlashSolid from "heroicons/24/solid/link-slash.svg?component-solid";
import Scissors from "heroicons/24/outline/scissors.svg?component-solid";
import ScissorsSolid from "heroicons/24/solid/scissors.svg?component-solid";
import DocumentDuplicateIcon from "heroicons/24/outline/document-duplicate.svg?component-solid";
import DocumentDuplicateSolid from "heroicons/24/solid/document-duplicate.svg?component-solid";
import DocumentArrowUpIcon from "heroicons/24/outline/document-arrow-up.svg?component-solid";
import DocumentArrowUpSolid from "heroicons/24/solid/document-arrow-up.svg?component-solid";
import GlobeAlt from "heroicons/24/outline/globe-alt.svg?component-solid";
import GlobeAltSolid from "heroicons/24/solid/globe-alt.svg?component-solid";
import Wifi from "heroicons/24/outline/wifi.svg?component-solid";
import WifiSolid from "heroicons/24/solid/wifi.svg?component-solid";
import Bookmark from "heroicons/24/outline/bookmark.svg?component-solid";
import BookmarkSolid from "heroicons/24/solid/bookmark.svg?component-solid";
import DevicePhoneMobile from "heroicons/24/outline/device-phone-mobile.svg?component-solid";
import DevicePhoneMobileSolid from "heroicons/24/solid/device-phone-mobile.svg?component-solid";
import DeviceTablet from "heroicons/24/outline/device-tablet.svg?component-solid";
import DeviceTabletSolid from "heroicons/24/solid/device-tablet.svg?component-solid";
import QrCode from "heroicons/24/outline/qr-code.svg?component-solid";
import QrCodeSolid from "heroicons/24/solid/qr-code.svg?component-solid";
import CameraIcon from "heroicons/24/outline/camera.svg?component-solid";
import CameraSolid from "heroicons/24/solid/camera.svg?component-solid";
import RectangleStack from "heroicons/24/outline/rectangle-stack.svg?component-solid";
import RectangleStackSolid from "heroicons/24/solid/rectangle-stack.svg?component-solid";
import Square3Stack3d from "heroicons/24/outline/square-3-stack-3d.svg?component-solid";
import Square3Stack3dSolid from "heroicons/24/solid/square-3-stack-3d.svg?component-solid";
import RocketLaunch from "heroicons/24/outline/rocket-launch.svg?component-solid";
import RocketLaunchSolid from "heroicons/24/solid/rocket-launch.svg?component-solid";
import ArrowsPointingOut from "heroicons/24/outline/arrows-pointing-out.svg?component-solid";
import ArrowsPointingOutSolid from "heroicons/24/solid/arrows-pointing-out.svg?component-solid";
import ArrowsPointingIn from "heroicons/24/outline/arrows-pointing-in.svg?component-solid";
import ArrowsPointingInSolid from "heroicons/24/solid/arrows-pointing-in.svg?component-solid";

const ICONS = {
  search: {
    outline: MagnifyingGlass,
    solid: MagnifyingGlassSolid,
  },
  reporting: {
    outline: ChartPie,
    solid: ChartPieSolid,
  },
  logout: {
    outline: ArrowLeftEndOnRectangle,
    solid: ArrowLeftEndOnRectangleSolid,
  },
  chevronLeft: {
    outline: ChevronLeft,
    solid: ChevronLeftSolid,
  },
  chevronRight: {
    outline: ChevronRight,
    solid: ChevronRightSolid,
  },
  "chevron-left": {
    outline: ChevronLeft,
    solid: ChevronLeftSolid,
  },
  "chevron-right": {
    outline: ChevronRight,
    solid: ChevronRightSolid,
  },
  "chevron-double-right": {
    outline: ChevronDoubleRight,
    solid: ChevronDoubleRightSolid,
  },
  chevronUp: {
    outline: ChevronUp,
    solid: ChevronUpSolid,
  },
  chevronDown: {
    outline: ChevronDown,
    solid: ChevronDownSolid,
  },
  "chevron-up": {
    outline: ChevronUp,
    solid: ChevronUpSolid,
  },
  "chevron-down": {
    outline: ChevronDown,
    solid: ChevronDownSolid,
  },
  info: {
    outline: InformationCircle,
    solid: InformationCircleSolid,
  },
  "face-smile": {
    outline: FaceSmileIcon,
    solid: FaceSmileSolidIcon,
  },
  "adjustments-horizontal": {
    outline: AdjustmentsHorizontal,
    solid: AdjustmentsHorizontalSolid,
  },
  procurement: {
    outline: BuildingStorefront,
    solid: BuildingStorefrontSolid,
  },
  credentialing: {
    outline: Identification,
    solid: IdentificationSolid,
  },
  membershipPlan: {
    outline: Ticket,
    solid: TicketSolid,
  },
  location: {
    outline: Map,
    solid: MapSolid,
  },
  feeSchedule: {
    outline: DocumentCurrencyDollar,
    solid: DocumentCurrencyDollarSolid,
  },
  dentalCodes: {
    outline: NumberedList,
    solid: NumberedListSolid,
  },
  "numbered-list": {
    outline: NumberedList,
    solid: NumberedListSolid,
  },
  user: {
    outline: User,
    solid: UserSolid,
  },
  switch: {
    outline: ArrowsRightLeft,
    solid: ArrowsRightLeftSolid,
  },
  "arrows-right-left": {
    outline: ArrowsRightLeft,
    solid: ArrowsRightLeftSolid,
  },
  "arrows-up-down": {
    outline: ArrowsUpDown,
    solid: ArrowsUpDownSolid,
  },
  "arrows-pointing-out": {
    outline: ArrowsPointingOut,
    solid: ArrowsPointingOutSolid,
  },
  "arrows-pointing-in": {
    outline: ArrowsPointingIn,
    solid: ArrowsPointingInSolid,
  },
  x: {
    outline: XMark,
    solid: XMarkSolid,
  },
  dashboard: {
    outline: Squares2X2,
    solid: Squares2X2Solid,
  },
  flag: {
    outline: Flag,
    solid: FlagSolid,
  },
  bolt: {
    outline: Bolt,
    solid: BoltSolid,
  },
  phone: {
    outline: Phone,
    solid: PhoneSolid,
  },
  "phone-incoming": {
    outline: PhoneArrowDownLeft,
    solid: PhoneArrowDownLeftSolid,
  },
  play: {
    outline: Play,
    solid: PlaySolid,
  },
  pause: {
    outline: Pause,
    solid: PauseSolid,
  },
  stop: {
    outline: Stop,
    solid: StopSolid,
  },
  "external-link": {
    outline: ArrowTopRightOnSquare,
    solid: ArrowTopRightOnSquareSolid,
  },
  "paper-clip": {
    outline: PaperClipIcon,
    solid: PaperClipIconSolid,
  },
  "x-circle": {
    outline: XCircle,
    solid: XCircleSolid,
  },
  "missed-call": {
    outline: PhoneXMark,
    solid: PhoneXMarkSolid,
  },
  keypad: {
    outline: Hashtag,
    solid: HashtagSolid,
  },
  heart: {
    outline: Heart,
    solid: HeartSolid,
  },
  dollar: {
    outline: CurrencyDollar,
    solid: CurrencyDollarSolid,
  },
  insurance: {
    outline: ShieldCheck,
    solid: ShieldCheckSolid,
  },
  "shield-check": {
    outline: ShieldCheck,
    solid: ShieldCheckSolid,
  },
  eligibility: {
    outline: EligibilityBadge,
    solid: EligibilityBadge,
  },
  pill: {
    outline: Pill,
    solid: Pill,
  },
  benefits: {
    outline: BenefitsBadge,
    solid: BenefitsBadge,
  },
  "benefits-filled": {
    outline: BenefitsFilledBadge,
    solid: BenefitsFilledBadge,
  },
  history: {
    outline: HistoryBadge,
    solid: HistoryBadge,
  },
  "check-circle": {
    outline: CheckCircle,
    solid: CheckCircleSolid,
  },
  message: {
    outline: ChatBubbleLeft,
    solid: ChatBubbleLeftSolid,
  },
  clock: {
    outline: Clock,
    solid: ClockSolid,
  },
  lab: {
    outline: Beaker,
    solid: BeakerSolid,
  },
  signature: {
    outline: DocumentCheck,
    solid: DocumentCheckSolid,
  },
  calendar: {
    outline: Calendar,
    solid: CalendarSolid,
  },
  note: {
    outline: DocumentText,
    solid: DocumentTextSolid,
  },
  cake: {
    outline: Cake,
    solid: CakeSolid,
  },
  family: {
    outline: UserGroup,
    solid: UserGroupSolid,
  },
  "light-bulb": {
    outline: LightBulb,
    solid: LightBulbSolid,
  },
  "arrow-trending-up": {
    outline: ArrowTrendingUp,
    solid: ArrowTrendingUpSolid,
  },
  "arrow-trending-down": {
    outline: ArrowTrendingDown,
    solid: ArrowTrendingDownSolid,
  },
  "arrow-up-circle": {
    outline: ArrowUpCircle,
    solid: ArrowUpCircleSolid,
  },
  "arrow-down-circle": {
    outline: ArrowDownCircle,
    solid: ArrowDownCircleSolid,
  },
  upload: {
    outline: ArrowUpTrayIcon,
    solid: ArrowUpTrayIconSolid,
  },
  "arrow-left": {
    outline: ArrowLeft,
    solid: ArrowLeftSolid,
  },
  "arrow-right": {
    outline: ArrowRight,
    solid: ArrowRightSolid,
  },
  "arrow-up": {
    outline: ArrowUp,
    solid: ArrowUpSolid,
  },
  "arrow-down": {
    outline: ArrowDown,
    solid: ArrowDownSolid,
  },
  "arrow-down-left": {
    outline: ArrowDownLeft,
    solid: ArrowDownLeftSolid,
  },
  "arrow-up-right": {
    outline: ArrowUpRight,
    solid: ArrowUpRightSolid,
  },
  "arrow-path": {
    outline: ArrowPath,
    solid: ArrowPathSolid,
  },
  plus: {
    outline: Plus,
    solid: PlusSolid,
  },
  return: {
    outline: ArrowUturnLeft,
    solid: ArrowUturnLeftSolid,
  },
  "ellipsis-horizontal-circle": {
    outline: EllipsisHorizontalCircle,
    solid: EllipsisHorizontalCircleSolid,
  },
  building: {
    outline: BuildingOffice2,
    solid: BuildingOffice2Solid,
  },
  charting: {
    outline: Star,
    solid: StarSolid,
  },
  "knowledge-base": {
    outline: BookOpen,
    solid: BookOpenSolid,
  },
  star: {
    outline: Star,
    solid: StarSolid,
  },
  sparkle: {
    outline: Sparkle,
    solid: Sparkle,
  },
  // Show/hide a side panel. Heroicons has no panel glyph.
  "panel-left": {
    outline: PanelLeft,
    solid: PanelLeft,
  },
  "microphone-slash": {
    outline: MicrophoneSlash,
    solid: MicrophoneSlash,
  },
  "twelve-mark": {
    outline: TweveMarkMono,
    solid: TwelveMark,
  },
  "unify-u": {
    outline: UnifyU,
    solid: UnifyU,
  },
  sparkles: {
    outline: Sparkles,
    solid: SparklesSolid,
  },
  ai: {
    outline: Sparkles,
    solid: SparklesSolid,
  },
  "lock-open": {
    outline: LockOpen,
    solid: LockOpenSolid,
  },
  "lock-closed": {
    outline: LockClosed,
    solid: LockClosedSolid,
  },
  check: {
    outline: Check,
    solid: CheckSolid,
  },
  ellipsisVertical: {
    outline: EllipsisVertical,
    solid: EllipsisVerticalSolid,
  },
  "ellipsis-vertical": {
    outline: EllipsisVertical,
    solid: EllipsisVerticalSolid,
  },
  "ellipsis-horizontal": {
    outline: EllipsisHorizontal,
    solid: EllipsisHorizontalSolid,
  },
  pencil: {
    outline: PencilIcon,
    solid: PencilIconSolid,
  },
  "question-mark-circle": {
    outline: QuestionMarkCircle,
    solid: QuestionMarkCircleSolid,
  },
  envelope: {
    outline: Envelope,
    solid: EnvelopeSolid,
  },
  trash: {
    outline: Trash,
    solid: TrashSolid,
  },
  banknotes: {
    outline: Banknotes,
    solid: BanknotesSolid,
  },
  "credit-card": {
    outline: CreditCard,
    solid: CreditCardSolid,
  },
  clipboard: {
    outline: Clipboard,
    solid: ClipboardSolid,
  },
  "clipboard-document-list": {
    outline: ClipboardDocumentList,
    solid: ClipboardDocumentListSolid,
  },
  "check-badge": {
    outline: CheckBadge,
    solid: CheckBadgeSolid,
  },
  "document-text": {
    outline: DocumentText,
    solid: DocumentTextSolid,
  },
  document: {
    outline: PlainDocument,
    solid: PlainDocumentSolid,
  },
  photo: {
    outline: Photo,
    solid: PhotoSolid,
  },
  beaker: {
    outline: Beaker,
    solid: BeakerSolid,
  },
  "exclamation-triangle": {
    outline: ExclamationTriangleIcon,
    solid: ExclamationTriangleIconSolid,
  },
  "user-plus": {
    outline: UserPlus,
    solid: UserPlusSolid,
  },
  microphone: {
    outline: Microphone,
    solid: MicrophoneSolid,
  },
  download: {
    outline: ArrowDownTray,
    solid: ArrowDownTraySolid,
  },
  printer: {
    outline: PrinterIcon,
    solid: PrinterIconSolid,
  },
  refresh: {
    outline: ArrowPath,
    solid: ArrowPathSolid,
  },
  funnel: {
    outline: Funnel,
    solid: FunnelSolid,
  },
  "cloud-arrow-up": {
    outline: CloudArrowUp,
    solid: CloudArrowUpSolid,
  },
  settings: {
    outline: Cog6Tooth,
    solid: Cog6ToothSolid,
  },
  menu: {
    outline: Bars3,
    solid: Bars3Solid,
  },
  "presentation-chart-line": {
    outline: PresentationChartLine,
    solid: PresentationChartLineSolid,
  },
  "hand-thumb-up": {
    outline: HandThumbUpIcon,
    solid: HandThumbUpIconSolid,
  },
  "hand-thumb-down": {
    outline: HandThumbDown,
    solid: HandThumbDownSolid,
  },
  users: {
    outline: UsersIcon,
    solid: UsersIconSolid,
  },
  "academic-cap": {
    outline: AcademicCap,
    solid: AcademicCapSolid,
  },
  "currency-dollar": {
    outline: CurrencyDollar,
    solid: CurrencyDollarSolid,
  },
  "chat-bubble-oval-left": {
    outline: ChatBubbleOvalLeft,
    solid: ChatBubbleOvalLeftSolid,
  },
  "chat-bubble-left-right": {
    outline: ChatBubbleLeftRight,
    solid: ChatBubbleLeftRightSolid,
  },
  "chart-bar": {
    outline: ChartBar,
    solid: ChartBarSolid,
  },
  "map-pin": {
    outline: MapPin,
    solid: MapPinSolid,
  },
  "building-office": {
    outline: BuildingOfficeIcon,
    solid: BuildingOfficeIconSolid,
  },
  "document-currency-dollar": {
    outline: DocumentCurrencyDollar,
    solid: DocumentCurrencyDollarSolid,
  },
  newspaper: {
    outline: NewspaperOutline,
    solid: NewspaperSolid,
  },
  eye: {
    outline: Eye,
    solid: EyeSolid,
  },
  "eye-slash": {
    outline: EyeSlashIcon,
    solid: EyeSlashIconSolid,
  },
  cog: {
    outline: Cog,
    solid: CogSolid,
  },
  tag: {
    outline: Tag,
    solid: TagSolid,
  },
  folder: {
    outline: FolderIcon,
    solid: FolderIconSolid,
  },
  "folder-open": {
    outline: FolderOpen,
    solid: FolderOpenSolid,
  },
  "folder-plus": {
    outline: FolderPlus,
    solid: FolderPlusSolid,
  },
  minus: {
    outline: Minus,
    solid: MinusSolid,
  },
  "paper-airplane": {
    outline: PaperAirplane,
    solid: PaperAirplaneSolid,
  },
  link: {
    outline: Link,
    solid: LinkSolid,
  },
  "link-slash": {
    outline: LinkSlashIcon,
    solid: LinkSlashSolid,
  },
  scissors: {
    outline: Scissors,
    solid: ScissorsSolid,
  },
  "document-duplicate": {
    outline: DocumentDuplicateIcon,
    solid: DocumentDuplicateSolid,
  },
  "document-arrow-up": {
    outline: DocumentArrowUpIcon,
    solid: DocumentArrowUpSolid,
  },
  globe: {
    outline: GlobeAlt,
    solid: GlobeAltSolid,
  },
  wifi: {
    outline: Wifi,
    solid: WifiSolid,
  },
  bookmark: {
    outline: Bookmark,
    solid: BookmarkSolid,
  },
  devicePhoneMobile: {
    outline: DevicePhoneMobile,
    solid: DevicePhoneMobileSolid,
  },
  "device-tablet": {
    outline: DeviceTablet,
    solid: DeviceTabletSolid,
  },
  "qr-code": {
    outline: QrCode,
    solid: QrCodeSolid,
  },
  camera: {
    outline: CameraIcon,
    solid: CameraSolid,
  },
  "rectangle-stack": {
    outline: RectangleStack,
    solid: RectangleStackSolid,
  },
  "square-3-stack-3d": {
    outline: Square3Stack3d,
    solid: Square3Stack3dSolid,
  },
  "rocket-launch": {
    outline: RocketLaunch,
    solid: RocketLaunchSolid,
  },
  "arrow-uturn-right": {
    outline: ArrowUturnRight,
    solid: ArrowUturnRightSolid,
  },
  "arrow-uturn-left": {
    outline: ArrowUturnLeft,
    solid: ArrowUturnLeftSolid,
  },
  "cursor-arrow-rays": {
    outline: CursorArrowRays,
    solid: CursorArrowRaysSolid,
  },
};

export type IconName = keyof typeof ICONS;

type IconProps = ComponentProps<"svg"> & {
  name: IconName;
  /** Defaults to `md` */
  size?: "xs" | "sm" | "md" | "lg" | "none";
};

export function Icon(props: IconProps) {
  const mergedProps = mergeProps({ size: "md" as const }, props);
  const [internalProps, svgProps] = splitProps(mergedProps, ["name", "size", "class"]);

  const makeVariant = (variant: "solid" | "outline") => {
    return () => (
      <Dynamic
        component={ICONS[internalProps.name][variant]}
        class={clsx(
          makeIconClass(internalProps.size),
          variant === "solid" ? "not-aria-within-current:hidden" : "aria-within-current:hidden",
          internalProps.class,
        )}
        data-icon-name={internalProps.name} // this helps llm know what the icon is, didn't want to use aria-label since may be used by callers of Icon
        {...svgProps}
      />
    );
  };

  const SolidIcon = makeVariant("solid");
  const OutlineIcon = makeVariant("outline");

  return (
    <>
      <SolidIcon />
      <OutlineIcon />
    </>
  );
}

export function RawIcon(
  props: ComponentProps<"svg"> & {
    name: IconName;
    size: IconProps["size"];
    variant: "solid" | "outline";
  },
) {
  const [internalProps, svgProps] = splitProps(props, ["name", "variant", "size", "class"]);
  return (
    <Dynamic
      component={ICONS[internalProps.name][internalProps.variant]}
      class={clsx(makeIconClass(internalProps.size), internalProps.class)}
      {...svgProps}
    />
  );
}

function makeIconClass(size: IconProps["size"]) {
  return clsx(
    "shrink-0",
    size === "xs" && "size-3",
    size === "sm" && "size-4",
    size === "md" && "size-5",
    size === "lg" && "size-6",
  );
}
